export type ProximityHandlerResult = {
    ProximityToClosest: number,
    CurrentlyClosest: HTMLElement | null;
    PreviouslyClosest: HTMLElement | null;
    DidChange: boolean
}
export class ProximityHandler {
    private proximityAttributeName: string = "drag-proximity";
    private handlerResult: ProximityHandlerResult;
    
    constructor() {
        this.handlerResult = { ProximityToClosest: 0, PreviouslyClosest: null, CurrentlyClosest: null, DidChange: false };
    }
    
    GetClosestToPoint = (x: number,y: number,selector: string,detectWithinPixels: number = 50):
        ProximityHandlerResult => {
        
        const elements: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>(selector);
        
        let nearest: null | HTMLElement = null;
        let nearestDist: number = Infinity;

        for (const el of elements) {
            const rect: DOMRect = el.getBoundingClientRect();
            const dist: number = this.distanceToRect(x, y, rect);
            const hasProximityClass: boolean = el.classList.contains('drag-proximity-point');
            
            if (dist === 0 && !hasProximityClass) {
                nearest = null;
                nearestDist = Infinity;
                break;
            }

            if (hasProximityClass) {
                if (dist < detectWithinPixels && dist < nearestDist) {
                    nearest = el;
                    nearestDist = dist;
                }
            }
        }

        const didChange: boolean = this.handlerResult.CurrentlyClosest != nearest;
        const previouslyClosest = didChange ? this.handlerResult.CurrentlyClosest : null;
        
        const newResult: ProximityHandlerResult = {
            ProximityToClosest: nearestDist,
            PreviouslyClosest: previouslyClosest,
            CurrentlyClosest: nearest,
            DidChange: didChange,
        };
        
        this.handlerResult = newResult;
        return newResult;
    }

    SetProximityAttributes(result: ProximityHandlerResult | null) {
        if(!result) result = this.handlerResult;
        
        if(result.PreviouslyClosest && result.PreviouslyClosest.hasAttribute(this.proximityAttributeName)) {
            result.PreviouslyClosest.removeAttribute(this.proximityAttributeName);
        }

        if(result.CurrentlyClosest && !result.CurrentlyClosest.hasAttribute(this.proximityAttributeName)) {
            result.CurrentlyClosest.setAttribute(this.proximityAttributeName, 'true');
        }
    }
    
    CleanUpProximityAttributes() {
        document.querySelectorAll('['+this.proximityAttributeName+']').forEach(el => {
            el.removeAttribute(this.proximityAttributeName);
        });
    }
    
    private distanceToRect(mouseX: number, mouseY: number, rect: DOMRect): number {
        const dx = Math.max(rect.left - mouseX, 0, mouseX - rect.right);
        const dy = Math.max(rect.top - mouseY, 0, mouseY - rect.bottom);
        return Math.sqrt(dx * dx + dy * dy);
    }    
}